export default __webpack_public_path__ + "static/media/seguro_emergencias.af52bc80.jpg";